import Vue from 'vue';
import { isPlainObject, has } from 'lodash';

export default {
  set(state, payload) {
    if (!payload.key) return;

    state[payload.key] = payload.value;
  },

  setCategories(state, categories) {
    state.categories = categories;
  },

  setActiveObject(state, obj) {
    if (typeof obj === 'string') {
      state.activeObject = state.activeObject && state.activeObject === obj ? null : obj;
    } else {
      state.activeObject = state.activeObject && state.activeObject.id === obj.id ? null : obj;
    }
    if (state.canvas.drawingMode) {
      Vue.set(state.canvas, 'drawingMode', false);
    }
    if (state.canvas.wavy) {
      Vue.set(state.canvas, 'wavy', false);
    }
  },

  removeActiveObject(state) {
    state.activeObject = null;
  },

  setBackground(state, background) {
    state.canvas.background = isPlainObject(background) ? background.imageUrl : background;
  },

  setCanvasObjects(state, objects) {
    state.canvasObjects = objects;

    if (
      !state.canvas.background &&
      !state.canvas.export &&
      has(state.canvasObjects, 'backgrounds[0].imageUrl')
    ) {
      state.canvas.background = state.canvasObjects.backgrounds[0].imageUrl;
    }
  },

  setCanvasColor(state, color) {
    state.canvas.color = color;
  },

  toggleDrawingMode(state) {
    state.canvas.drawingMode = !state.canvas.drawingMode;
    Vue.set(state.canvas, 'wavy', false);
    Vue.set(state.canvas, 'dashed', false);
  },

  removeDrawingMode(state) {
    Vue.set(state.canvas, 'drawingMode', false);
  },

  setLineWidth(state, width) {
    if (width < 1) {
      state.canvas.lineWidth = 1;
    } else if (width > 150) {
      state.canvas.lineWidth = 150;
    } else {
      state.canvas.lineWidth = width;
    }
  },

  export(state, json) {
    state.canvas.export = json;
  },

  exportImage(state, image) {
    state.canvas.image = image;
  },

  updateFilter(state, payload) {
    Vue.set(state[payload.filterKey || 'filters'], payload.filter, payload.value);
  },

  resetFilters(state, payload) {
    Vue.set(state[payload.filterKey], 'title', '');
    Vue.set(state[payload.filterKey], 'objectiveIds', []);
    Vue.set(state[payload.filterKey], 'toApprove', 0);
    Vue.set(state[payload.filterKey], 'toApproveFilter', 0);
    Vue.set(state[payload.filterKey], 'globalCoachId', null);
    Vue.set(state[payload.filterKey], 'companyCoachId', null);
    Vue.set(state[payload.filterKey], 'tagIds', []);
    Vue.set(state[payload.filterKey], 'categoryIds', []);
    Vue.set(state[payload.filterKey], 'hasVideo', 0);
    Vue.set(state[payload.filterKey], 'playersNumber', [0,22]);
    Vue.set(state[payload.filterKey], 'exerciseMinutes', [0,120]);
  },

  paginate(state, payload) {
    state[payload.name] = payload.value;
  },

  toggleWavy(state) {
    state.canvas.wavy = !state.canvas.wavy;
    Vue.set(state.canvas, 'drawingMode', false);
  },

  removeWavy(state) {
    Vue.set(state.canvas, 'wavy', false);
    Vue.set(state.canvas, 'dashed', false);
  },

  setDashed(state, value) {
    state.canvas.dashed = value;
  },
  setOpacity(state, value) {
    state.canvas.opacity = value;
  },

  getTopTags(state, value) {
    state.topTags = value;
  },
};



// WEBPACK FOOTER //
// ./src/store/exercises/mutations.js